import { CANDY_APPLE_LIGHT, OZ_LIGHT } from 'HubStyleTokens/colors';
import AcceptedStatusInfo from 'flow-doctor-lib/components/filters/AcceptedStatusInfo';
import WalmartFilterEvaluationDataPopover from 'flow-doctor-lib/components/filters/WalmartFilterEvaluationDataPopover';
import WalmartFilterEvaluationValue from 'flow-doctor-lib/components/filters/WalmartFilterEvaluationValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class ILSFilterRenderAdapter {
  constructor(filter) {
    this.filter = filter;
  }
  getFilter() {
    return this.filter;
  }
  renderDetailsComponent() {
    return null;
  }
  renderEvalutionValueComponent() {
    return null;
  }
  getBackgroundColor() {
    return undefined;
  }
}
export class DebugFilterRenderAdapter {
  constructor(debugFilter, displayMode) {
    this.debugFilter = debugFilter;
    this.displayMode = displayMode;
  }
  getFilter() {
    return this.debugFilter.filter;
  }
  renderDetailsComponent(objectTypeId) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AcceptedStatusInfo, {
        acceptedStatus: this.debugFilter.acceptedStatus,
        displayMode: this.displayMode
      }), !this.shouldHideEvaluationData() && /*#__PURE__*/_jsx(WalmartFilterEvaluationDataPopover, {
        evaluationData: this.debugFilter.evaluationData,
        objectTypeId: objectTypeId
      })]
    });
  }
  renderEvalutionValueComponent(objectTypeId) {
    if (this.shouldHideEvaluationData()) {
      return null;
    }
    return /*#__PURE__*/_jsx(WalmartFilterEvaluationValue, {
      evaluationData: this.debugFilter.evaluationData,
      objectTypeId: objectTypeId
    });
  }
  getBackgroundColor() {
    // Special case for when we want to still display the rejected filter, but without the rejection UI to avoid confusion
    if (this.shouldHideEvaluationData()) {
      return undefined;
    }
    return DebugFilterRenderAdapter.COLORS_FOR_ACCEPTED_STATUS[this.debugFilter.acceptedStatus];
  }
  shouldHideEvaluationData() {
    return this.displayMode === 'OPTIMISTIC_ACCEPTED' && this.debugFilter.acceptedStatus === 'REJECTED';
  }
}
DebugFilterRenderAdapter.COLORS_FOR_ACCEPTED_STATUS = {
  ACCEPTED: OZ_LIGHT,
  REJECTED: CANDY_APPLE_LIGHT,
  DEFERRED: CANDY_APPLE_LIGHT,
  // TODO: Figure out if we should show a different indicator for incomplete evals
  INCOMPLETE: CANDY_APPLE_LIGHT
};